import React from 'react';
import PropTypes from 'prop-types';

import Price from '../../classes/finance/price';
import { CreateSearchForm } from '../Controls/Subscriptions';
import { VIEW_MODE } from '../../consts';
import { IconPriceDynamic } from '../Icons';

function SearchHeader (props) {
  const avgPrice = new Price(props.avgPrice);
  const avgPricePer = new Price(props.avgPricePerSquareMeter || props.avgPricePerAre);
  const per = props.avgPricePerSquareMeter ? Price.PER_SQUARE_METER : Price.PER_AR;

  const displayModeHeader = props.filter && props.filter.get('viewMode') === VIEW_MODE.map ? 'inline-block' : 'inline';

  return (
    <div className='search-header'>
      <h1 className='h1' style={{display: displayModeHeader}}>
        {props.title || 'Недвижимость'}
      </h1>

      <div className='flex flex-between sub-header'>
        <div className='left-side'>

          {
            avgPrice.getValue() ? <span className='avg-price'>Средняя цена {avgPrice.getLabel()}&nbsp;({avgPricePer.getLabel(per, '/')})</span> : null
          }
          {
            props.showDynamic && (
              <a target='blank' className='dynamic-price' href='/office/statistic/'>
                <IconPriceDynamic />
                <span>Динамика цен</span>
              </a>
            )
          }
        </div>
        <div className='right-side'>
          { props.filter &&
            <CreateSearchForm
              eventOnOpen={props.eventSaveSearch}
              filter={props.filter}
              eventSubscriptionForCian={props.eventSubscriptionForCian}
            /> }
        </div>
      </div>
    </div>
  );
}

SearchHeader.propTypes = {
  title: PropTypes.string,
  filter: PropTypes.object.isRequired,
  avgPricePerSquareMeter: PropTypes.number,
  avgPricePerAre: PropTypes.number,
  avgPrice: PropTypes.number,
  showDynamic: PropTypes.bool,

  eventSubscription: PropTypes.func,
  eventSaveSearch: PropTypes.func,
  eventSubscriptionForCian: PropTypes.func,
};

SearchHeader.defaultProps = {
  title: 'Недвижимость',
  avgPricePerSquareMeter: null,
  avgPricePerAre: null,
  avgPrice: null,
  showDynamic: true,

  eventSubscription: () => {},
  eventSaveSearch: () => {},
  eventSubscriptionForCian: () => {}
};

export default SearchHeader;



// WEBPACK FOOTER //
// ./src/ui/Header/SearchHeader.jsx